import React from "react";
import { Box } from "@mui/material";
import {
  HeroSection,
  ProjectsSection,
  ServicesSection,
  StatsSection,
  CTASection,
} from "../components/home";

function Home() {
  return (
    <Box>
      <HeroSection />
      <ServicesSection />
      <ProjectsSection />
      <StatsSection />
      <CTASection />
    </Box>
  );
}

export default Home;
